import _ from 'underscore';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useConfirmDialog } from '@bingads-webui-campaign-react/common-hooks';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { MultiCouponDialogContent } from './multi-coupon-dialog-content';
import { DEFAULT_ACTIVITY } from '../helpers';

export function useMultiCouponDialog(props) {
  const {
    activity = DEFAULT_ACTIVITY,
    newCoupon,
    oldCoupon,
    onCouponSelected,
    getCouponCurrencyCode = _.noop,
  } = props;
  const i18n = useContext(I18nContext);

  const [selectedCoupon, setSelectedCoupon] = useState(null);

  useEffect(() => {
    if (_.isNull(selectedCoupon) && newCoupon) {
      setSelectedCoupon(newCoupon);
    }
  }, [newCoupon, selectedCoupon]);

  const handleSelectedCouponChanged = useCallback((coupon) => {
    setSelectedCoupon(coupon);
  }, []);

  const handleDismissDialog = useCallback(() => {
    activity.trace('[Coupon Prompt]: Dismiss MultiCouponDialog');
    onCouponSelected(oldCoupon, true);
  }, [activity, onCouponSelected, oldCoupon]);

  const handleConfirmDialog = useCallback(() => {
    activity.trace(`[Coupon Prompt]: Confirmed MultiCouponDialog ${selectedCoupon.couponString}`);
    onCouponSelected(selectedCoupon || newCoupon);
  }, [newCoupon, onCouponSelected, selectedCoupon, activity]);

  const content = useMemo(() => (
    <MultiCouponDialogContent
      newCoupon={newCoupon}
      oldCoupon={oldCoupon}
      onSelectedCouponChange={handleSelectedCouponChanged}
      getCouponCurrencyCode={getCouponCurrencyCode}
    />
  ), [getCouponCurrencyCode, handleSelectedCouponChanged, newCoupon, oldCoupon]);

  const dialogTitleText = useMemo(() => i18n.getString(_TL_('Oops!')), [i18n]);
  const confirmButtonText = useMemo(() => i18n.getString(_TL_('Claim')), [i18n]);

  return useConfirmDialog({
    title: dialogTitleText,
    content,
    confirmText: confirmButtonText,
    onConfirm: handleConfirmDialog,
    onCancel: handleDismissDialog,
    className: 'multi-coupon-dialog-root',
    modalProps: { isBlocking: true },
  }, {
    activity,
    dialogName: 'MultiCouponDialog',
  });
}
